import { SubstrateSearchScenario } from '../data/schema/SubstrateSearchScenario';
import { getGlobalSettingsAccountMailboxInfo } from 'owa-account-source-list-store';
import { getHasArchive } from 'owa-session-store';
import { isGlobalFeatureEnabled } from 'owa-feature-flags';

/**
 * Helper function to return "X-Client-Flights" header value to compose with
 * server flights
 */
export default function getXClientFlightsHeaderValue(
    scenarioId: SubstrateSearchScenario,
    isRecursiveSearch?: boolean
): string | undefined {
    if (scenarioId !== SubstrateSearchScenario.Mail) {
        return undefined;
    }

    const flightNames: string[] = ['OWA_BestMatch_V15'];
    flightNames.push('CalendarInsightsFlight');

    if (getHasArchive(getGlobalSettingsAccountMailboxInfo())) {
        flightNames.push('OWA_HasArchiveMailbox');
    }

    const tidbitsSearchFlights = [
        'EESForEmailConv',
        'EESForEmailConvSsa',
        'EnableTidBits',
        'EnableTidBits2',
        'PopulateTidBits',
        'PopulateTidBits2',
    ];

    for (const tidbitFlight of tidbitsSearchFlights) {
        flightNames.push(tidbitFlight);
    }

    if (isRecursiveSearch) {
        flightNames.push('DisableAncestorContainerIDOnlyValidation');
    }

    if (isGlobalFeatureEnabled('sea-searchPlusChat-hydratedAndPlainPromptSuggestions')) {
        flightNames.push(
            'enablePromptAutoSuggestProvider',
            'enablePASForOwaC',
            'EnableHydratedPromptsOutlookQF'
        );
    } else if (isGlobalFeatureEnabled('sea-searchPlusChat-plainPromptSuggestionsOnly')) {
        flightNames.push('enablePromptAutoSuggestProvider', 'enablePASForOwaC');
    }

    return flightNames.length > 0 ? flightNames.join(',') : undefined;
}
